// Get the current item that was clicked and show the variants container
function showQuickAddVariants(button, variantId) {
  const card = button.parentNode;
  const variants = card.querySelector("#quickAddVariants");

  if (variantId) {
    sendUpsellEventToGA4(variantId);
  }

  if (!variants) {
    return;
  }

  if (variants.style.display === "none") {
    variants.style.display = "block";
  } else {
    variants.style.display = "none";
  }
}

// Close the current item variant container
function closeQuickAddVariants(closeButton) {
  // Calls parentNode three times as the child is nested three times.
  const parent = closeButton.parentNode.parentNode.parentNode;
  parent.style.display = "none";
}

// Close Variant quick add drawer once added to cart
function variantAdded(variant, variantId) {
  setTimeout(() => {
    const parent = variant.closest(".variant-drawer");
    parent.style.display = "none";
  }, 500);

  sendUpsellEventToGA4(variantId);
}

function sendUpsellEventToGA4(variantId) {
  sendUpsellAddToCartToGA4();
  getGa4Object(variantId)
    .then((ga4Object) => {
      const variantId = ga4Object._variantId;
      delete ga4Object._variantId;
      ga4Object.event = "quick_add_to_cart";
      ga4Object.value = ga4Object.price;
      ga4Object.quantity = 1;
      sessionStorage.setItem(variantId, JSON.stringify(ga4Object));
      if (window.dataLayer) {
        window.dataLayer.push(ga4Object);
        console.log("Pushed object for quick_add_to_cart event: ", ga4Object);
      }
    })
    .catch(() => {
      console.error(
        "Cannot push object for quick add to cart event. No object found for the event"
      );
    });
}
